// TODO: legal review required before public launch.
// Mandatory under TMG §5 / DDG §5 and §18 MStV. Fill in all [PLACEHOLDERS]
// in the translation files (legal.imprint.*) before going live.

import { useTranslation } from "react-i18next";

import { LegalPageLayout, LegalSection } from "@/components/layout/LegalPageLayout";

export default function Imprint() {
  const { t } = useTranslation();

  return (
    <LegalPageLayout title={t("legal.imprint.title", { defaultValue: "Imprint" })}>
      <LegalSection title={t("legal.imprint.sections.provider.title", { defaultValue: "Information pursuant to § 5 DDG / § 5 TMG" })}>
        <address className="not-italic rounded-md border border-border bg-muted/50 px-4 py-3 leading-relaxed">
          <strong className="block font-ui text-foreground">[COMPANY_NAME]</strong>
          <span className="block text-muted-foreground">[LEGAL_FORM_AND_REPRESENTATIVE]</span>
          <span className="block text-muted-foreground">[STREET_AND_NUMBER]</span>
          <span className="block text-muted-foreground">[POSTAL_CODE] [CITY]</span>
          <span className="block text-muted-foreground">[COUNTRY]</span>
        </address>
      </LegalSection>

      <LegalSection title={t("legal.imprint.sections.contact.title", { defaultValue: "Contact" })}>
        <ul className="space-y-1">
          <li>
            {t("legal.imprint.sections.contact.phoneLabel", { defaultValue: "Telephone" })}: [PHONE]
          </li>
          <li>
            {t("legal.imprint.sections.contact.emailLabel", { defaultValue: "Email" })}:{" "}
            <a href="mailto:deutschgenie.contact@gmail.com" className="text-primary hover:underline">
              deutschgenie.contact@gmail.com
            </a>
          </li>
        </ul>
      </LegalSection>

      <LegalSection title={t("legal.imprint.sections.register.title", { defaultValue: "Register Entry" })}>
        <ul className="space-y-1">
          <li>{t("legal.imprint.sections.register.court", { defaultValue: "Register court" })}: [REGISTER_COURT]</li>
          <li>{t("legal.imprint.sections.register.number", { defaultValue: "Register number" })}: [REGISTER_NUMBER]</li>
        </ul>
      </LegalSection>

      <LegalSection title={t("legal.imprint.sections.vat.title", { defaultValue: "VAT Identification Number" })}>
        <p>
          {t("legal.imprint.sections.vat.body", {
            defaultValue:
              "VAT identification number pursuant to § 27 a of the German VAT Act (UStG): [VAT_ID]",
          })}
        </p>
      </LegalSection>

      <LegalSection title={t("legal.imprint.sections.responsible.title", { defaultValue: "Responsible for content pursuant to § 18 (2) MStV" })}>
        <address className="not-italic">
          <span className="block">[RESPONSIBLE_PERSON_NAME]</span>
          <span className="block text-muted-foreground">[RESPONSIBLE_PERSON_ADDRESS]</span>
        </address>
      </LegalSection>

      <LegalSection title={t("legal.imprint.sections.odr.title", { defaultValue: "EU Dispute Resolution" })}>
        <p>
          {t("legal.imprint.sections.odr.body", {
            defaultValue:
              "The European Commission provides a platform for online dispute resolution (ODR):",
          })}{" "}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
          .
        </p>
        <p>
          {t("legal.imprint.sections.odr.notice", {
            defaultValue:
              "We are neither obliged nor willing to participate in dispute resolution proceedings before a consumer arbitration board.",
          })}
        </p>
      </LegalSection>

      <LegalSection title={t("legal.imprint.sections.liability.title", { defaultValue: "Liability for Content and Links" })}>
        <p>
          {t("legal.imprint.sections.liability.content", {
            defaultValue:
              "As a service provider we are responsible for our own content on these pages in accordance with general law (§ 7 (1) DDG). According to §§ 8–10 DDG, we are not obliged to monitor transmitted or stored third-party information, or to investigate circumstances that indicate illegal activity.",
          })}
        </p>
        <p>
          {t("legal.imprint.sections.liability.links", {
            defaultValue:
              "Our pages may contain links to external third-party websites whose content we cannot influence. We accept no liability for these external contents. The respective provider or operator of the linked pages is always responsible for their content.",
          })}
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
